import normalizeWheel from 'normalize-wheel'
import maskSvg from './2020.svg'
import { lerp, mouse } from '@/js/utils'

const TEXT_COUNT = 10
const TEXT_SIZE = 2500

export default function (parentEl, start) {
  parentEl.style.display = 'flex'
  parentEl.style.alignItems = 'center'

  const wrapper = document.createElement('div')
  wrapper.classList.add('wrapper')
  wrapper.style.backgroundColor = '#fff'
  wrapper.style.width = '100%'
  wrapper.style.height = '100%'

  const mask = document.createElement('div')
  mask.classList.add('mask')
  mask.style.backgroundImage = 'url(' + maskSvg + ')'
  mask.style.backgroundRepeat = 'no-repeat'
  mask.style.transform = 'perspective(1000px) rotate3d(0,0,0,2deg)'

  const texts = []

  for (let i = 0; i < TEXT_COUNT; i++) {
    texts[i] = document.createElement('p')
    texts[i].textContent = 'Points Lignes Plans Points Lignes Plans Points Lignes Plans'
    texts[i].style.margin = 0
    texts[i].style.fontSize = '224px'
    texts[i].style.fontWeight = 800
    texts[i].style.lineHeight = '0.9em'
    texts[i].style.whiteSpace = 'nowrap'
    texts[i].style.fontFamily = 'var(--font-grand)'
    texts[i].style.color = 'var(--pink)'

    if (i % 2 === 0) {
      texts[i].style.transform = 'translate(-8px, 0px)'
    } else {
      texts[i].style.transform = 'translate(' + (TEXT_SIZE - 8) + 'px, 0px)'
    }
    wrapper.append(texts[i])
  }

  parentEl.append(mask)
  parentEl.append(wrapper)

  let x = 0
  let wheel = 0
  let rotateX = 0
  let rotateY = 0

  window.addEventListener('wheel', e => {
    wheel = Math.max(Math.min(wheel + normalizeWheel(e).pixelY / 10, TEXT_SIZE), 0)
  })

  start()

  return function () {
    x = lerp(x, wheel, 0.1)
    rotateX = lerp(rotateX, mouse.xn, 0.05)
    rotateY = lerp(rotateY, mouse.yn, 0.05)

    mask.style.transform = `perspective(1000px) rotate3d(${rotateX},${rotateY},1,5deg) translate3d(0,0,150px)`

    for (let i = 0; i < TEXT_COUNT; i++) {
      if (i % 2 === 0) {
        texts[i].style.transform = `translate(${-x - 100}px, 0px)`
      } else {
        texts[i].style.transform = `translate(${-TEXT_SIZE + 100 + (x)}px, 0px)`
      }
    }
  }
}
